import { getContinuousPlayEnabledTrackingStatus } from '../video/shared/smart-tag-adapter/continous-play';
// START A/B TEST PLGRWEB-1558 Live Sports Data Carousel
import { getToggleEnabledStatus } from '../abTests/testClasses/LiveSportsDataCarousel';
// END A/B TEST PLGRWEB-1558 Live Sports Data Carousel
import { removeCookie } from 'helpers/VanillaCookie';

(function () {
    window.CBS = window.CBS || {};
    CBS.Tracking = {};
    var isOmAvailable = false;
    var checkOm = setInterval(function () {
        if (typeof om != 'undefined' && !isOmAvailable) {
            isOmAvailable = true;
            CBS.Promises.Tracking.resolve();
            clearInterval(checkOm);
        }
    }, 200);

    /**
     * temporary helper function, this should go away when refactor the whole thing
     * @param sName
     * @returns {string}
     */
    function getCookie(sName) {
        var oCrumbles = document.cookie.split(';');
        for (var i = 0; i < oCrumbles.length; i++) {
            var oPair = oCrumbles[i].split('=');
            var sKey = decodeURIComponent(oPair[0].trim());
            var sValue = oPair.length > 1 ? oPair[1] : '';
            if (sKey == sName) {
                return decodeURIComponent(sValue);
            }
        }
        return '';
    }

    CBS.Tracking = {
        utag_data: {},

        setMvpdPartner: function () {
            var mvpdAuthz = getCookie('mvpd_authz');
            if (mvpdAuthz) {
                var mvpd = JSON.parse(mvpdAuthz);
                if (mvpd.mvpd_name && mvpd.mvpd_name.length > 1) {
                    this.utag_data.mvpdPartner = mvpd.mvpd_display_name; // || mvpd.mvpd_name;
                    var id = mvpd.token.match('<mvpdId>(.*)</mvpdId>');
                    if (id.length == 2 && id[1].length > 1) {
                        this.utag_data.mvpdPartnerId = id[1];
                    }
                    this.utag_data.mvpdAuthenticated = '1';
                } else {
                    this.utag_data.mvpdAuthenticated = '0';
                }
            }
        },

        SetTracking: function (trackingOBJ) {
            // if (CBS.Registry.platform.pageType === 'HOMEPAGE') {             //Please keep -- this to be subject of a fast follow.
            //     this.utag_data.slideId = (typeof window.__slideId !== 'undefined') ? window.__slideId : ''
            //     this.utag_data.slideTitle = (typeof window.__slideTitle !== 'undefined') ? window.__slideTitle : ''
            //     this.utag_data.slideCTA = (typeof window.__slideCTA !== 'undefined') ? window.__slideCTA : ''
            //     this.utag_data.slideType = (typeof window.__slideType !== 'undefined') ? window.__slideType : ''
            //     this.utag_data.rowHeaderTitle = (typeof window.__rowHeaderTitle !== 'undefined') ? window.__rowHeaderTitle : ''
            //     this.utag_data.posRowNum = (typeof window.__slideId !== 'undefined') ? "0" : ''
            //     this.utag_data.posColNum = (typeof window.__slideId !== 'undefined') ? "0" : ''
            //     this.utag_data.showSeriesId = (typeof window.__showId !== 'undefined') ? window.__showId : 'na'
            //     this.utag_data.showSeriesTitle = (typeof window.__showSeriesTitle !== 'undefined') ? window.__showSeriesTitle : 'na'
            //     this.utag_data.showEpisodeId = (typeof window.__showEpisodeId !== 'undefined') ? window.__showEpisodeId : 'na'
            //     this.utag_data.showEpisodeTitle = (typeof window.__showEpisodeTitle !== 'undefined') ? window.__showEpisodeTitle : 'na'
            //     this.utag_data.slideTarget = (typeof window.__slideTarget !== 'undefined') ? window.__slideTarget : '';
            //     this.utag_data.spliceEnabled = (typeof window.__spliceEnabled !== 'undefined') ? window.__spliceEnabled : '';
            // }

            // if we have a  live TV channel in play, attempt track its current listing title
            if (CBS.Registry?.channelInfo) {
                const cookieName = 'channelContentId';
                try {
                    const channelContentId = getCookie(cookieName);
                    if (channelContentId) {
                        const channelInfo = CBS.Registry.channelInfo;
                        let channelListing = channelInfo?.currentListing[0] ?? null;
                        if (channelContentId && channelInfo?.currentListing?.length > 0) {
                            channelInfo?.currentListing.forEach((listing) => {
                                if (listing?.videoContentId === channelContentId) {
                                    channelListing = listing;
                                }
                            });
                        }
                        if (channelListing) {
                            this.utag_data.currentListingTitle = channelListing?.title ?? '';
                        }
                        removeCookie(cookieName);
                    }
                } catch (e) {}
            }
            if (CBS.Registry.platform.isMobile) {
                this.utag_data.deviceType = 'mobile';
            } else {
                this.utag_data.deviceType = 'desktop';
            }

            this.utag_data.siteEdition = trackingOBJ.tealium.siteEdition;
            CBS.Registry.siteEdition = trackingOBJ.tealium.siteEdition;

            this.utag_data.siteType = 'responsive web';

            if (typeof trackingOBJ.tealium.showTitle != 'undefined') {
                this.utag_data.showTitle = trackingOBJ.tealium.showTitle;
            }

            if (typeof trackingOBJ.tealium.movieBrowseCategory != 'undefined') {
                this.utag_data.movieBrowseCategory = trackingOBJ.tealium.movieBrowseCategory;
            }

            if (typeof trackingOBJ.movieId != 'undefined') {
                this.utag_data.movieId = trackingOBJ.movieId;
                this.utag_data.movieTitle = trackingOBJ.movieTitle;
                this.utag_data.movieGenre =
                    typeof window.__genre !== 'undefined'
                        ? window.__genre
                        : trackingOBJ.tealium.movieGenre;
            }

            if (typeof trackingOBJ.subscriptionLevel != 'undefined') {
                this.utag_data.subscriptionLevel = trackingOBJ.subscriptionLevel;
            }
            if (typeof trackingOBJ.tealium.showSectionTitle != 'undefined') {
                this.utag_data.showSectionTitle = trackingOBJ.tealium.showSectionTitle;
            }
            if (typeof trackingOBJ.tealium.movieSectionTitle != 'undefined') {
                this.utag_data.movieSectionTitle = trackingOBJ.tealium.movieSectionTitle;
            }
            if (typeof trackingOBJ.tealium.movieGenre != 'undefined') {
                this.utag_data.movieGenre = trackingOBJ.tealium.movieGenre;
            }
            if (typeof trackingOBJ.tealium.showBrowseCategory != 'undefined') {
                this.utag_data.showBrowseCategory = trackingOBJ.tealium.showBrowseCategory;
            }
            if (typeof trackingOBJ.showGenre != 'undefined') {
                this.utag_data.showGenre = trackingOBJ.showGenre;
                trackingOBJ.tealium.showGenre = trackingOBJ.showGenre;
            }
            if (typeof trackingOBJ.dma != 'undefined') {
                this.utag_data.dma = trackingOBJ.dma;
                trackingOBJ.tealium.dma = trackingOBJ.dma;
            }
            if (typeof trackingOBJ.tealium.showId != 'undefined') {
                this.utag_data.showId = trackingOBJ.tealium.showId;
            }
            if (typeof trackingOBJ.tealium.showSeriesId != 'undefined') {
                this.utag_data.showSeriesId = trackingOBJ.tealium.showSeriesId;
            }
            if (typeof trackingOBJ.tealium.showEpisodeLabel != 'undefined') {
                this.utag_data.showEpisodeLabel = trackingOBJ.tealium.showEpisodeLabel;
            }
            if (typeof trackingOBJ.pageURL != 'undefined') {
                this.utag_data.pageURL = trackingOBJ.pageURL;
            }

            if (typeof trackingOBJ.status != 'undefined') {
                this.utag_data.status = trackingOBJ.status;
            }

            if (typeof trackingOBJ.DW_page_type != 'undefined') {
                this.utag_data.pageType = trackingOBJ.DW_page_type;
                this.utag_data.pageType = this.utag_data.pageType.toLowerCase();
                this.utag_data.articleType = this.utag_data.pageType;
            }

            this.utag_data.autoPlayEnabled = getContinuousPlayEnabledTrackingStatus() ?? '1';

            // START A/B TEST PLGRWEB-1558 Live Sports Data Carousel
            this.utag_data.toggleEnabled = getToggleEnabledStatus();
            // END A/B TEST PLGRWEB-1558 Live Sports Data Carousel

            $.extend(this.utag_data, trackingOBJ.tealium);

            // TODO: can't figure out WHERE this should be set; putting here for now
            this.utag_data.packageStatus = CBS.Registry.user.packageStatus ?? '';

            var showDayPart = trackingOBJ.tealium.showDayPart;
            var showGenre = trackingOBJ.tealium.showGenre ?? '';
            var siteSectionPreSet = !!this.utag_data.siteSection;
            var siteHierPreSet = !!this.utag_data.siteHier;
            if (showDayPart && showGenre && this.utag_data.pageType && this.utag_data.showTitle) {
                var hierShowTitle = this.utag_data.showTitle.toLowerCase().replace('!', '');
                if (!siteHierPreSet) {
                    this.utag_data.siteHier = [
                        showDayPart,
                        showGenre,
                        hierShowTitle,
                        this.utag_data.pageType,
                    ].join('|');
                }

                this.utag_data.showSecCategory = this.utag_data.pageType;
                this.utag_data.showGenre = trackingOBJ.tealium.showGenre;
                if (!siteSectionPreSet) {
                    this.utag_data.siteSection = this.utag_data.showDaypart =
                        trackingOBJ.tealium.showDayPart;
                }
            } else {
                if (!siteSectionPreSet) {
                    this.utag_data.siteSection = this.utag_data.pageType;
                }

                if (!siteHierPreSet) {
                    this.utag_data.siteHier = this.utag_data.pageType;
                }
            }

            var siteHier;
            if (siteSectionPreSet) {
                siteHier = this.utag_data.siteSection;
            } else if (this.utag_data.section) {
                var section = (siteHier = this.utag_data.section);
                var str = section.split('|');
                this.utag_data.siteSection = str[0];
            }

            if (siteHier && !siteHierPreSet) {
                this.utag_data.siteHier = siteHier;
            }

            if (typeof this.utag_data.registrationDriver != 'undefined') {
                this.utag_data.userRegDriver = this.utag_data.registrationDriver;
            }

            if (typeof trackingOBJ.__CBS_HOME__ == 'undefined') {
                this.utag_data.show = this.utag_data.showTitle;
            } else {
                this.utag_data.pageType = 'front_door';
            }

            this.utag_data.userRegId = CBS.Registry.user.id || '';
            this.utag_data.userType = CBS.Registry.user.sb;

            try {
                if (typeof window.__page_uuid !== 'undefined') {
                    this.utag_data.pageViewGuid = window.__page_uuid;
                }
            } catch (e) {}

            if (typeof trackingOBJ.BK_sb != 'undefined') {
                this.utag_data.BK_sb = trackingOBJ.BK_sb;
            }

            if (typeof trackingOBJ.userType != 'undefined') {
                this.utag_data.userType = trackingOBJ.userType;
            }

            if (typeof trackingOBJ.userHash != 'undefined') {
                this.utag_data.userHash = trackingOBJ.userHash;
            }

            if (trackingOBJ.brandPlatformId != 'undefined') {
                this.utag_data.brandPlatformId = trackingOBJ.brandPlatformId;
            }

            //if the page is trying to setup any utag_data video related points
            if (typeof trackingOBJ.videoUTAG != 'undefined' && trackingOBJ.videoUTAG == true) {
                this.utag_data.brandPlatformId = trackingOBJ.brandPlatformId;
                this.utag_data.vod_type = trackingOBJ.vod_type;
                this.utag_data.mediaContentType = trackingOBJ.mediaType;
                this.utag_data.showEpisodeId = trackingOBJ.showEpisodeId;
                this.utag_data.showEpisodeTitle = trackingOBJ.showEpisodeTitle;
            }

            if (typeof trackingOBJ.tealium.contentBrand !== 'undefined') {
                this.utag_data.contentBrand = trackingOBJ.tealium.contentBrand;
            } else {
                this.utag_data.contentBrand = 'na';
            }
            if (document.location.href.indexOf('/watch-free') > 1) {
                this.utag_data.contentBrand = 'na';
            }

            if (
                (document.location.href.indexOf('/shows/') > 1 ||
                    document.location.href.indexOf('/movies/') > 1) &&
                this.utag_data.pageType == 'home'
            ) {
                this.utag_data.spliceEnabled = $('.marqueeVideo').length ? '1' : '0';
            }

            CBS.Registry.context_override = $.extend(
                CBS.Registry.context_override,
                trackingOBJ.tealiumOverride,
            );

            if (CBS.Registry.context_override) {
                this.utag_data = $.extend(this.utag_data, CBS.Registry.context_override);
            }

            if (
                document.location.href.indexOf('/all-access') > 1 ||
                document.location.href.indexOf('/live-tv') > 1
            ) {
                if (typeof this.utag_data.order_refnum != 'undefined') {
                    this.utag_data.purchaseOrderRefNum = this.utag_data.order_refnum;
                }

                if (typeof this.utag_data.show != 'undefined') {
                    this.utag_data.show = '';
                    this.utag_data.showId = '';
                    this.utag_data.showTitle = '';
                }

                // Paramount+ hack to remap variables until they are properly input into the CMS
                if (typeof this.utag_data.eventType != 'undefined') {
                    this.utag_data.pageEvent = this.utag_data.eventType;
                }
            }

            if (document.location.href.indexOf('/live-tv') > 1) {
                this.utag_data.mediaContentType = 'live';
                if (typeof this.utag_data.isSPA == 'undefined' || !this.utag_data.isSPA) {
                    this.utag_data.channelBrowseCategory = 'all';
                }
            }

            //Track if link came from internal search
            var __internal_search_referral = window.localStorage.getItem(
                'internal_search_referral',
            );
            if (__internal_search_referral) {
                this.utag_data.internalSearchReferral = 'true';
                window.localStorage.removeItem('internal_search_referral');
            }

            try {
                this.setDesktopShowNavTracking();
                this.setDesktopActivityMapGlobalNavShowsSubNav();
                this.setDesktopActivityMapWatchRelatedShows();
                this.setMvpdPartner();
                this.setOverrides(trackingOBJ);
                this.setAdPath(trackingOBJ);
            } catch (e) {
                console.log(e);
            }

            return this.utag_data;
        },

        setAdPath: function (trackingOBJ) {
            if (typeof this.utag_data.path != 'undefined') return;

            var pType = this.utag_data.pageType
                ? this.utag_data.pageType.replace(/_/gi, '-')
                : 'home';
            if (typeof trackingOBJ.__CBS_HOME__ != 'undefined') {
                this.utag_data.path = 'home';
            } else if (
                trackingOBJ.tealium &&
                trackingOBJ.tealium.showTitle &&
                trackingOBJ.tealium.showDayPart
            ) {
                var arr_pieces = [
                    trackingOBJ.tealium.showTitle
                        .replace(/ /gi, '-')
                        .replace(/[\[\]']+|&|:|;|!|[,.]|\+/gi, '')
                        .replace('--', '-')
                        .toLocaleLowerCase(),
                    pType,
                ];
                var dp = trackingOBJ.tealium.showDayPart.replace(/ /gi, '-');
                if (dp != 'not') arr_pieces.unshift(dp);

                this.utag_data.path = arr_pieces.join('/');
            } else {
                this.utag_data.path = pType;
            }
        },

        setDesktopShowNavTracking: function () {
            if (!CBS.Registry.homepage) {
                try {
                    $('#globalShowHeader .menuItems a').each(function (index) {
                        $(this).on('click', function (e) {
                            CBS.Tracking.setClickTrackingBeforeHref(e, $(this), {
                                item:
                                    'show nav|' +
                                    $(this).text().toLowerCase() +
                                    '|pos' +
                                    (index + 1) +
                                    '|click',
                            });
                        });
                        $(this).attr(
                            'aa-link',
                            'show nav|' +
                                $(this).text().toLowerCase() +
                                '|' +
                                (index + 1) +
                                '|click',
                        );
                    });
                    $('#marqueeShowHeader .menuItems a').each(function (index) {
                        $(this).on('click', function (e) {
                            CBS.Tracking.setClickTrackingBeforeHref(e, $(this), {
                                item:
                                    'show nav|' +
                                    $(this).text().toLowerCase() +
                                    '|pos' +
                                    (index + 1) +
                                    '|click',
                            });
                        });
                        $(this).attr(
                            'aa-link',
                            'show nav|' +
                                $(this).text().toLowerCase() +
                                '|' +
                                (index + 1) +
                                '|click',
                        );
                    });

                    $('#tryAllAccessButton').click(function (e) {
                        CBS.Tracking.setClickTrackingBeforeHref(e, $(this), {
                            item:
                                'Try One Week FREE|' +
                                utag_data._pageName +
                                '|marquee|branding|click',
                        });
                    });

                    $('.watchLatestButton').click(function (e) {
                        CBS.Tracking.setClickTrackingBeforeHref(e, $(this), {
                            item: 'Watch Latest|' + utag_data._pageName + '|marquee|branding|click',
                        });
                    });

                    $('#allAccessMarqueeContainer').click(function (e) {
                        CBS.Tracking.setClickTrackingBeforeHref(e, $(this), {
                            item: 'Watch Latest|' + utag_data._pageName + '|drawer|branding|click',
                        });
                    });
                } catch (e) {
                    console.warn(e);
                }
            }
        },

        setOverrides: function (trackingOBJ) {
            if (
                document.location.href.indexOf('/schedule') > 1 ||
                (document.location.href.indexOf('/watch') > 1 &&
                    document.location.href.indexOf('/watch_magazine') < 1) ||
                this.utag_data.showTitle == 'show listings' ||
                document.location.href.indexOf('/user/mycbs') > 1 ||
                document.location.href.indexOf('/user/signup') > 1
            ) {
                this.utag_data.showTitle = null;
                this.utag_data.showId = null;
                this.utag_data.articleType = null;
            }

            if (document.location.href.indexOf('/user/mycbs') > 1) {
                this.utag_data.pageType = 'mycbs';
            }
            if (
                document.location.href.indexOf('/watch') > 1 &&
                document.location.href.indexOf('/watch_magazine') < 1
            ) {
                this.utag_data.siteSection = 'other';
                this.utag_data.siteHier = 'other|other|watch|home';
                this.utag_data.pageType = 'video_door';
            }

            if (this.utag_data.showTitle == 'show listings') {
                this.utag_data.pageType = 'category_doors';
            }

            if (document.location.href.indexOf('/roku') > 1) {
                this.utag_data.pageType = 'roku_activation';
                this.utag_data.siteHier = 'home|roku_activation';
            }

            if (document.location.href.indexOf('/rokusweeps') > 1) {
                this.utag_data.pageType = 'roku_sweeps';
                this.utag_data.siteHier = 'home|roku_sweeps';
            }

            if (document.location.href.indexOf('/holidaysweeps') > 1) {
                this.utag_data.pageType = 'holiday_sweeps';
                this.utag_data.siteHier = 'sweepstakes|holiday_sweeps';
            }

            if (document.location.href.indexOf('/movies/') > 1) {
                let split = document.location.href.split('/movies/');
                let second_part = split[1];
                let slashes = second_part.split('/');

                this.utag_data.showGenre = null;
                this.utag_data.showBrowseCategory = null;
                this.utag_data.userType = trackingOBJ.userType;

                let prev_page_split = document.referrer.split('/');

                if ((document.location.href.match(/.*\/movies\/$/) || []).length > 0) {
                    // edge case for when user clicks on movie browse button on global nav, will only match URL that ends in "/movies/"
                    this.utag_data.movieBrowseCategory = 'popular';
                    this.utag_data.pageURL = '/movies/';
                } else if (prev_page_split.length <= 6) {
                    // check if previous url is from movie browse instead of a movie page
                    // length will be 7 for '/movies/video/{MOVIE_ID}/' and 6 for '/movies/comedy/'
                    if (
                        typeof this.utag_data.movieId === 'undefined' &&
                        document.referrer.indexOf('/movies/') > 1
                    ) {
                        this.utag_data.movieGenre = null;

                        if (slashes.length === 1) {
                            this.utag_data.movieBrowseCategory = 'popular';
                            this.utag_data.pageURL = '/movies/';
                        } else {
                            this.utag_data.movieBrowseCategory =
                                slashes[0] == 'all' ? 'All Movies' : slashes[0];
                            this.utag_data.pageURL = '/movies/' + slashes[0] + '/';
                        }
                    } else {
                        this.utag_data.pageType = 'movie';
                    }
                }
            }

            if (document.location.href.indexOf('/browse/') > 1) {
                let split = document.location.href.split('/browse/');
                let second_part = split[1];
                let slashes = second_part.split('/');

                if (this.utag_data.showSeriesId === null) {
                    this.utag_data.showGenre = null;
                    this.utag_data.movieGenre = null;
                    this.utag_data.movieBrowseCategory = null;
                    if (slashes.length === 1) {
                        this.utag_data.showBrowseCategory = 'popular';
                        this.utag_data.pageURL = '/shows/';
                    } else {
                        this.utag_data.showBrowseCategory =
                            slashes[0] == 'all' ? 'All Shows' : slashes[0];
                        this.utag_data.pageURL = '/shows/' + slashes[0] + '/';
                    }
                } else {
                    if (typeof trackingOBJ.tealium.pageType != 'undefined') {
                        this.utag_data.pageType = trackingOBJ.tealium.pageType;
                    } else {
                        this.utag_data.pageType = 'show';
                    }
                }
            }
        },

        setViewTracking: function () {
            try {
                this.getPageGuid();
            } catch (e) {}
        },

        setClickTrackingBeforeHref: function (e, obj, params) {
            e.preventDefault();
            var orgUrl = obj.attr('href');
            var orgTarget = obj.attr('target');
            try {
                if (typeof om != 'undefined') {
                    om.trackClick(params);
                }
                setTimeout(function () {
                    if (orgTarget == '_blank' || orgTarget == '_new') {
                        window.open(orgUrl);
                    } else {
                        window.location.href = orgUrl;
                    }
                }, 500);
            } catch (e) {
                if (orgTarget == '_blank' || orgTarget == '_new') {
                    window.open(orgUrl);
                } else {
                    window.location.href = orgUrl;
                }
            }
        },

        setTrackSocialClick: function (type) {
            try {
                if (typeof om != 'undefined') {
                    om.trackSocialClick({
                        socialService: type,
                    });
                }
            } catch (e) {
                console.log(e);
            }
        },

        clickTrackButton: function (buttonName) {
            try {
                if (typeof om != 'undefined') {
                    om.trackClick({
                        item: utag_data.showId + '|' + utag_data._pageType + '|' + buttonName,
                    });
                }
            } catch (e) {}
        },

        clickTrackTaboola: function (placement) {
            try {
                if (typeof om != 'undefined') {
                    $('body').delegate('[om-event]', 'click', function (e) {
                        om.trackClick({ item: placement });
                    });
                }
            } catch (e) {}
        },

        mt_rand: function (min, max) {
            var argc = arguments.length;
            if (argc === 0) {
                min = 0;
                max = 2147483647;
            } else if (argc === 1) {
                throw new Error('Warning: mt_rand() expects exactly 2 parameters, 1 given');
            } else {
                min = parseInt(min, 10);
                max = parseInt(max, 10);
            }
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },

        getPageGuid: function () {
            // require(['jquery', '_cbs'], function (_cbs) {
            var pGuid = uuid.v4();

            if (typeof om != 'undefined') {
                om.trackView({
                    pageViewGuid: pGuid,
                });
            }

            try {
                window.__page_uuid = pGuid;
                googletag.pubads().setTargeting('vguid', pGuid);
            } catch (e) {}
            // });
        },

        setDesktopActivityMapGlobalNavShowsSubNav: function () {
            var showNames = $('#globalShowsDropDown .show-nav-link');
            $.each(showNames, function (index) {
                var showName = $(this).text().toLowerCase();
                $(this).attr(
                    'aa-link',
                    'global nav|shows|' + showName + '|' + (index + 1) + '|click',
                );
            });
        },

        setDesktopActivityMapWatchRelatedShows: function () {
            $('#relatedShowsCarousel').on('DOMNodeInserted', '#relatedShowsCarousel', function () {
                var showNames = $('.jcarousel-item .relatedShows .wp-tooltip');
                $.each(showNames, function (index) {
                    var showPath = $(this).attr('href');
                    var showName = $(this).attr('title').toLowerCase();
                    $(this).attr(
                        'aa-link',
                        'Show|' +
                            CBS.Registry.Show.name +
                            '|Related Shows|' +
                            showName +
                            '|' +
                            (index + 1),
                    );
                });
            });
        },
    };
})();
